import { useMediaQuery } from "react-responsive";

export const IsTablet = () => {
    const _isTablet = useMediaQuery({ query: '(max-width: 1250px)' });
    const _isTabletDevice = useMediaQuery({ query: '(max-device-width: 1250px)' });

    return _isTablet || _isTabletDevice ? true : false;
}